import { render, staticRenderFns } from "./DialogFormBankExternal.vue?vue&type=template&id=15c8d36b"
import script from "./DialogFormBankExternal.vue?vue&type=script&lang=js"
export * from "./DialogFormBankExternal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports